import {PessoaSisbi} from './pessoa-sisbi';
import { ServicoInspecaoSisbi } from './servico-inspecao-sisbi';

export class EstabelecimentoSisbi {

    csEstabelecimento: string;
    csSituacaoEstabelecimento: string;
    dsJustificativa: string;
    dtRegistro: string;
    idEndereco: number;
    idEstabSisbi: number;
    idTipoSituacaoEscopo: number;
    nome: string;
    nrProcesso: string;
    nrRegistro: string;
    pessoa: PessoaSisbi;
    servicoInspecao: ServicoInspecaoSisbi;
    sgUf: string;
    nmMunicipio: string;

    get id(): number {
        return this.idEstabSisbi;
    }

    get nomeEstabelicimento(): string {
        if (this.pessoa.isPessoaJuridica) {
            return this.pessoa.pessoaJuridica.nmRazaoSocial;
        }
        if (this.pessoa.isPessoaFisica) {
            return this.pessoa.pessoaFisica.nmPessoaFisica;
        }
        return '';
    }
    get situacaoEstabelecimento(): string {
        switch (this.csSituacaoEstabelecimento) {
            case 'A':
                return 'Ativo';
            case 'I':
                return 'Inativo';
            case 'P':
                return 'Pendente';
            case 'S':
                return 'Suspenso';
            case 'R':
                return 'Rascunho';
            case 'E':
                return 'Estagnado';
        }
    }

    /**
     * Converte um objeto json em instancias da classe
     */
    static fromJson(jsonData: any): EstabelecimentoSisbi {
        if (jsonData.pessoa != null) {
            jsonData.pessoa = PessoaSisbi.fromJson(jsonData.pessoa);
        }
        if (jsonData.servicoInspecao != null) {
            jsonData.servicoInspecao = ServicoInspecaoSisbi.fromJson(jsonData.servicoInspecao);
        }
        return Object.assign(new EstabelecimentoSisbi(), jsonData);
    }

}
